import { logger } from '@fiverr-private/obs';
import { isClient } from '../../../utils/isClient';
import { reportGrafanaEvent } from '../../../utils/events/grafana/reporter';
import { DEFAULT_ATTEMPTS, DEFAULT_DELAY } from './constants';

export const waitForWindowMethod = (methodName) => new Promise((resolve, reject) => {
    const hasMethod = () => typeof window !== 'undefined' && typeof window[methodName] === 'function';

    if (hasMethod()) {
        resolve();
        return;
    }

    let currentAttempt = 0;

    const interval = setInterval(() => {
        if (currentAttempt >= DEFAULT_ATTEMPTS) {
            clearInterval(interval);
            reject();
            return;
        }

        if (hasMethod()) {
            clearInterval(interval);
            resolve();
        }

        currentAttempt++;
    }, DEFAULT_DELAY);
});

const businessTriger = (methodName) => async(params = {}) => {
    const { modalOptions = {}, biEnrichmentParams = {} } = params;

    if (!isClient()) {
        return;
    }

    try {
        await waitForWindowMethod(methodName);

        return window[methodName](modalOptions, biEnrichmentParams);
    } catch (e) {
        logger.warn(`User Session Trigger: Failed to resolve a trigger for business ${methodName}`);
        reportGrafanaEvent(`identification.trigger.business.fail.${methodName}`);
    }
};

export const businessOpenSignUp = businessTriger('openSignUpModal');

export const businessOpenSignIn = businessTriger('openSignInModal');
